import { render, staticRenderFns } from "./CarnivalDrawer.vue?vue&type=template&id=1fce8295&scoped=true"
import script from "./CarnivalDrawer.vue?vue&type=script&lang=js"
export * from "./CarnivalDrawer.vue?vue&type=script&lang=js"
import style0 from "./CarnivalDrawer.vue?vue&type=style&index=0&id=1fce8295&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce8295",
  null
  
)

export default component.exports